import { motion } from "framer-motion";
import { LINKS, LOGO_URL, scrollToId } from "@/data";

const NAV_ITEMS = [
  { label: "L'EP", id: "album", testid: "nav-link-album" },
  { label: "Live", id: "live", testid: "nav-link-live" },
  { label: "Booking", id: "booking", testid: "nav-link-booking" },
  { label: "La Band", id: "band", testid: "nav-link-band" },
  { label: "Foto", id: "gallery", testid: "nav-link-gallery" },
  { label: "Studio", id: "studio", testid: "nav-link-studio" },
  { label: "Merch", id: "merch", testid: "nav-link-merch" },
  { label: "Instagram", id: "instagram", testid: "nav-link-instagram" },
];

export default function Navbar() {
  return (
    <motion.header
      data-testid="nav-header"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className="fixed top-0 left-0 right-0 z-50 border-b border-red-950/60 bg-black/80 backdrop-blur-md"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 sm:px-8">
        <button
          data-testid="nav-logo-button"
          onClick={() => window.__lenis?.scrollTo(0)}
          className="flex items-center gap-3"
        >
          <img
            src={LOGO_URL}
            alt="Linea Cremisi"
            data-testid="nav-logo-image"
            className="h-9 w-9 rounded-full border border-red-900/50 object-cover"
          />
          <span className="font-serif-logo text-sm font-800 tracking-[0.25em] text-neutral-100 sm:text-base">
            LINEA CREMISI
          </span>
        </button>

        <nav className="hidden items-center gap-6 lg:flex xl:gap-8">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.id}
              data-testid={item.testid}
              onClick={() => scrollToId(item.id)}
              className="font-mono-tac text-xs uppercase tracking-[0.3em] text-neutral-400 transition-colors duration-200 hover:text-red-500"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <span
            data-testid="nav-release-pill"
            className="hidden items-center gap-2 border border-red-900/60 px-3 py-1.5 sm:flex"
          >
            <span className="live-dot inline-flex h-2 w-2 rounded-full bg-red-600" />
            <span className="font-mono-tac text-[10px] uppercase tracking-[0.25em] text-red-500">
              Fuori ora
            </span>
          </span>
          <a
            data-testid="nav-listen-now-button"
            href={LINKS.spotify}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#C8102E] px-4 py-2 font-mono-tac text-xs uppercase tracking-[0.2em] text-white transition-all duration-200 hover:bg-[#FF2A4B] hover:shadow-[0_0_25px_rgba(200,16,46,0.6)]"
          >
            Ascolta
          </a>
        </div>
      </div>
    </motion.header>
  );
}
